import { InjectionToken } from '@angular/core';
import { Configuration } from '@lx/shared/types';

export const CONFIGURATION: InjectionToken<Configuration> = new InjectionToken<Configuration>('CONFIGURATION');
